"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UNASSOCIATED_MAIL_ERROR_CODES = exports.linkUnassociatedMailSchema = exports.UNASSOCIATED_MAIL_PAGE_SIZE = exports.INBOUND_EMAIL_STATES = exports.TICKET_INBOUND_EVENT_TYPE_LABELS = exports.TICKET_INBOUND_EVENT_TYPES = exports.TICKET_INBOUND_ORIGINS = exports.AUTOMATIC_REPLY_NOTICE = exports.SENDER_AUTHENTICATION_NOTICES = exports.INBOUND_SENDER_AUTHENTICATIONS = exports.UNRECOGNIZED_SENDER_NOTICE = exports.TICKET_INBOUND_MESSAGE_KIND_LABELS = exports.TICKET_INBOUND_MESSAGE_KINDS = void 0;
exports.senderAuthentication = senderAuthentication;
exports.rejectedAttachmentsNotice = rejectedAttachmentsNotice;
const zod_1 = require("zod");
/**
 * Posta in ingresso (ADR-003 «In entrata» e «Posta non associata», story #42): le repliche di chi
 * ha segnalato rientrano nel thread come messaggi dell'utente; le email senza un codice
 * riconoscibile finiscono nella lista della posta non associata. Chiavi in inglese come le altre
 * API degli operatori, valori di dominio in italiano.
 */
/**
 * Tipi di messaggio del thread che arrivano per email: `utente` = il mittente coincide con l'email
 * di chi ha segnalato; `utente_non_riconosciuto` = mittente diverso (o che non supera DMARC),
 * conservato e visibile ma senza effetto sullo stato (ADR-003, in entrata punto 3).
 */
exports.TICKET_INBOUND_MESSAGE_KINDS = ['utente', 'utente_non_riconosciuto'];
exports.TICKET_INBOUND_MESSAGE_KIND_LABELS = {
    utente: 'Replica via email',
    utente_non_riconosciuto: 'Email da un mittente non riconosciuto',
};
/** Avviso della replica non riconosciuta nel thread (mittente diverso da chi ha segnalato). */
exports.UNRECOGNIZED_SENDER_NOTICE = "Il mittente non coincide con l'email di chi ha segnalato: il messaggio è conservato senza effetti sullo stato.";
/**
 * Esito dell'autenticazione del mittente secondo il fornitore (DMARC): `superata` (`pass`),
 * `fallita` (`fail`: la replica è sempre «non riconosciuta») o `non_verificata` (ogni altro
 * verdetto o nessuno: la replica entra come messaggio dell'utente, con l'avviso). Decisione del
 * product owner del 02/10/2026 (PR #55).
 */
exports.INBOUND_SENDER_AUTHENTICATIONS = ['superata', 'non_verificata', 'fallita'];
/** L'esito dal verdetto DMARC del fornitore (in minuscolo; `null` se assente). */
function senderAuthentication(dmarcResult) {
    if (dmarcResult === 'pass')
        return 'superata';
    return dmarcResult === 'fail' ? 'fallita' : 'non_verificata';
}
/** Avvisi del thread e della posta non associata sull'autenticazione del mittente. */
exports.SENDER_AUTHENTICATION_NOTICES = {
    non_verificata: "Mittente non verificato: il fornitore della posta non ha potuto confermare che l'email venga davvero da questo indirizzo.",
    fallita: "Autenticazione del mittente non superata: l'email potrebbe non venire da questo indirizzo. Il messaggio è conservato senza effetti sullo stato.",
};
/** Avviso della risposta automatica (fuori ufficio, risponditore): registrata senza effetti né notifica. */
exports.AUTOMATIC_REPLY_NOTICE = 'Risposta automatica: registrata senza effetti sullo stato e senza notifica.';
/**
 * Come il messaggio è arrivato nel ticket: `replica` = dal codice nell'indirizzo o dalle
 * intestazioni di thread; `collegata` = un operatore l'ha collegata dalla posta non associata.
 */
exports.TICKET_INBOUND_ORIGINS = ['replica', 'collegata'];
/**
 * Testo che la replica dichiara quando aveva allegati (ADR-003 punto 7). Le immagini inline del
 * corpo (`content_disposition: inline`, firme e loghi) non contano.
 */
function rejectedAttachmentsNotice(count) {
    const what = count === 1 ? '1 allegato non accettato' : `${count} allegati non accettati`;
    return `${what}: in questa versione gli allegati delle email non sono conservati.`;
}
/**
 * Eventi del thread della posta in ingresso: `posta_collegata` = un operatore ha collegato al
 * ticket un'email della posta non associata (`details` = `{ membro: { id, nome }, postaId, messaggio }`).
 */
exports.TICKET_INBOUND_EVENT_TYPES = ['posta_collegata'];
exports.TICKET_INBOUND_EVENT_TYPE_LABELS = {
    posta_collegata: 'Email collegata dalla posta non associata',
};
/** Stato di un'email in ingresso, nel registro della posta in ingresso. */
exports.INBOUND_EMAIL_STATES = ['associata', 'non_associata', 'collegata', 'scartata'];
/** Quante email in attesa la lista restituisce, dalla più recente. */
exports.UNASSOCIATED_MAIL_PAGE_SIZE = 100;
/** Corpo di `POST /api/v1/unassociated-mail/:id/link`: il codice del ticket esistente. */
exports.linkUnassociatedMailSchema = zod_1.z.strictObject({
    ticketCode: zod_1.z
        .string({ error: 'Codice del ticket: campo obbligatorio' })
        .trim()
        .min(1, { error: 'Scrivi il codice del ticket', abort: true })
        .max(40, { error: 'Codice del ticket non valido' })
        .transform((value) => value.toUpperCase()),
});
/** Codici di errore della posta non associata, nel campo `code` del corpo di errore dell'API. */
exports.UNASSOCIATED_MAIL_ERROR_CODES = {
    /** Nessuna email della posta in ingresso con quell'id. */
    notFound: 'posta_non_associata.non_trovata',
    /** L'email è già stata collegata o scartata (anche da un collega nel frattempo). */
    alreadyHandled: 'posta_non_associata.gia_gestita',
};
//# sourceMappingURL=inbound-mail.js.map